import React, { ChangeEvent, useEffect, useMemo, useState } from "react";

import "../../Styles/CommonStyles.scss";

import {
  Button,
  DeleteButton,
  // Label,
  SecondaryBlueButton,
  // SecondaryButton,
  // SecondaryWhiteButton,
} from "../StyledComp/StyledComp";
import MemberServices from "../../services/MemberServices";
import { useDispatch, useSelector } from "react-redux";
import { resetSearchParameters } from "../../store/searchMemberApiSlice";
import { PageLink } from "../../components/StyledComp/StyledComp";
import { RootState } from "../../store/store";
import { useAppSelector } from "../../store/hooks";
import {
  ICreateMemberBody,
  IStateType,
} from "../../store/memberInterfaceStruct";
import ReactModal from "react-modal";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs, { Dayjs } from "dayjs";
import {
  // searchMemberApiSlice,
  updateSearchBody,
} from "../../store/searchMemberApiSlice";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  updateSearchParamFlags,
  resetSearchParamFlags,
} from "../../store/hasSearchParamFlags";
import IMember from "../../store/memberInterfaceStruct";
import { updateMemberList } from "../../store/findMemberUpdatedApiSlice";
import {
  setMemberCurrentPage,
  setMemberPaginate,
  setUpdateSortBy,
  setUpdateSortType,
  // updateFM_MemberId,
} from "../../store/memberApiSlice";
import {
  // useTable,
  Column,
  // useSortBy
} from "react-table";
import moment from "moment";
// import AlertIcon from "../../Images/Alert";
import RoundButtonWithIcon from "../StyledComp/RoundButtonWithIcon";
import LeftArrowIcon from "../../Images/LeftArrowIcon";
import { TextField } from "@mui/material";
import {
  ICost,
  ILocation,
  // IMembership,
  IOrderItem,
  IVideoCost,
  resetOrderParameters,
  storeAddOrderItemVideoCost,
  storeRemoveOrderItemVideoCost,
  storeUpdateOrder,
  storeUpdateOrderItem,
} from "../../store/orderApiSlice";
import {
  IGuestOrderItem,
  IGuestOrder,
  storeResetGuestOrder,
  storeUpdateGuestOrder,
  storeAddGuestOrderItemCosts,
  storeRemoveGuestOrderItemCosts,
  storeUpdateGuestOrderItem,
  storeRemoveGuestOrderItemVideoCost,
  storeAddGuestOrderItemVideoCost,
} from "../../store/guestOrderApiSlice";
import { Controller, useForm } from "react-hook-form";
import { Cost, IEvent } from "../../store/eventApiSlice";
import OrderServices from "../../services/OrderServices";
import EventMemberPaymentInfo from "./EventMemberPaymentInfo";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface IConfiguration {
  [key: string]: any;
}

interface IProps {
  callOrderAPI?: () => void;
  operationType?: string; //"Create", "Edit"
  closeModal?: () => void;
}

// type FormValues = {
//   FirstName: string;
//   LastName: string;
// };

const EventAddGuest: React.FC<IProps> = (props) => {
  const dispatch = useDispatch();
  const form = useForm<IGuestOrder>();
  let storeTrasactionAmount = useAppSelector(
    (store) => store.guestOrderapislice.TotalAmount
  );
  const guestOrderInfo = useAppSelector((store) => store.guestOrderapislice);

  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );

  const { register, control, handleSubmit, formState, setValue, clearErrors } =
    form;
  const { errors, touchedFields, dirtyFields } = formState;

  const [orderEventDetailModalOpen, setOrderEventDetailModalOpen] =
    useState<boolean>(false);

  const eventInfo: IEvent = useSelector(
    (state: RootState) => state.eventapislice.event
  );

  const [eventCostList, setEventCostList] = useState<ICost[]>([]);
  const [eventCostIdList, setEventCostIdList] = useState<number[]>([]);
  const [callAPIflag, setCallAPIflag] = useState<boolean>(false);

  //const [totalAmount, setTotalAmount] = useState<number>(0);

  const videoCostList: IVideoCost[] = [
    {
      Id: 101,
      CostName: "MemberCost",
      Cost: eventInfo.MemberCost,
    },
    {
      Id: 102,
      CostName: "NonMemberCost",
      Cost: eventInfo.NonMemberCost,
    },
  ];

  const [datePaid, setDatePaid] = useState<Dayjs | null>(
    guestOrderInfo?.DatePaid ? dayjs(guestOrderInfo.DatePaid) : null
  );
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const color1 = "#2d6289";
  // const color2 = "#008800";

  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        error: {
          main: color1,
        },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
              // Left: "-4%",
              // Top: "10%",
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
              Left: "-4% !important",
              Top: "10%",
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

  useEffect(() => {
    const getConfigurationLists = async () => {
      console.log("getConfigurationLists called");
      // dispatch(resetCreateBody());

      const response = await MemberServices.getConfigurationList();
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        // console.log("response1...", response.data.data);
        setConfigurationLists(response.data.data);
      }
    };
    // guestOrderInfo.DatePaid !== null
    //   ? setDatePaid(dayjs(guestOrderInfo.DatePaid, "YYYY-MM-DD"))
    //   : null;

    // if (dayjs(guestOrderInfo.DatePaid).isValid()) {
    //   setValue("DatePaid", dayjs(guestOrderInfo.DatePaid!), {
    //     shouldDirty: true,
    //   });
    // }

    // console.log("Dates1:", datePaid, "-", guestOrderInfo.DatePaid);
    getConfigurationLists();
  }, []);

  useEffect(() => {
    if (datePaid && dayjs.isDayjs(datePaid) && datePaid.isValid()) {
      setValue("DatePaid", datePaid.format("YYYY-MM-DD"), {
        shouldDirty: true,
      });
    }
  }, [datePaid]);

  useEffect(() => {
    if (callAPIflag === true) {
      console.log("before callOrderAPI", guestOrderInfo);
      if (props.callOrderAPI) {
        props.callOrderAPI();
      }
    }
    setCallAPIflag(false);
    console.log("orderInfo Changed:", guestOrderInfo);
  }, [guestOrderInfo, callAPIflag]);

  useEffect(() => {
    if (storeTrasactionAmount) {
      //setTransactionAmount(storeTrasactionAmount);
      // Update transactionAmount when storeTrasactionAmount changes
      console.log("storeTrasactionAmount-useeffect", storeTrasactionAmount);
    }
  }, [storeTrasactionAmount]);

  useEffect(() => {
    if (datePaid !== null) {
      dispatch(
        storeUpdateGuestOrder({
          key: "DatePaid",
          value: dayjs(datePaid, "YYYY-MM-DD").format("YYYY-MM-DD"),
        })
      );
    }
    console.log("Dates2:", datePaid, "-", guestOrderInfo.DatePaid);
  }, [datePaid, guestOrderInfo.DatePaid]);

  const [modalOpen, setModalOpen] = useState(false);

  const openOrderEventDetail = (event: React.MouseEvent<HTMLElement>) => {
    setOrderEventDetailModalOpen(true);
    console.log("EventFindMember Select:");
    // setMember(member);
  };

  const formatPhoneNumber = (input: any) => {
    if (input == null) {
      return null;
    } else {
      // Remove all non-digit characters
      let numericInputFormatted = input.replace(/\D/g, "");

      // Apply formatting based on length
      if (numericInputFormatted.length > 6) {
        numericInputFormatted = numericInputFormatted.replace(
          /(\d{3})(\d{3})(\d{0,4})/,
          "($1) $2-$3"
        );
      } else if (numericInputFormatted.length > 3) {
        numericInputFormatted = numericInputFormatted.replace(
          /(\d{3})(\d{0,3})/,
          "($1) $2"
        );
      } else if (numericInputFormatted.length > 1) {
        numericInputFormatted = numericInputFormatted.replace(
          /(\d{0,3})/,
          "($1"
        );
      }

      return numericInputFormatted.trim();
    }
  };

  const updatePersonalInfo = (e: any, date?: Date | null) => {
    switch (e.target.name) {
      case "FirstName":
        dispatch(
          storeUpdateGuestOrder({
            key: "FirstName",
            value: e.target.value,
          })
        );
        break;

      case "LastName":
        dispatch(
          storeUpdateGuestOrder({
            key: "LastName",
            value: e.target.value,
          })
        );
        break;
      case "Gender":
        dispatch(
          storeUpdateGuestOrder({
            key: "Gender",
            value: e.target.value,
          })
        );
        break;

      case "PhoneNumber":
        dispatch(
          storeUpdateGuestOrder({
            key: "PhoneNumber",
            value: e.target.value,
          })
        );
        break;

      case "Email":
        dispatch(
          storeUpdateGuestOrder({
            key: "Email",
            value: e.target.value,
          })
        );
        break;

      case "Address1":
        dispatch(
          storeUpdateGuestOrder({
            key: "Address1",
            value: e.target.value,
          })
        );
        break;

      case "Address2":
        dispatch(
          storeUpdateGuestOrder({
            key: "Address2",
            value: e.target.value,
          })
        );
        break;

      case "City":
        dispatch(
          storeUpdateGuestOrder({
            key: "City",
            value: e.target.value,
          })
        );
        break;

      case "State":
        dispatch(
          storeUpdateGuestOrder({
            key: "State",
            value: e.target.value,
          })
        );
        break;

      case "Zipcode":
        dispatch(
          storeUpdateGuestOrder({
            key: "Zipcode",
            value: e.target.value,
          })
        );
        break;

      default:
        break;
    }
  };

  // const [tempTransactionAmount, setTempTransactionAmount] =
  //   useState<number>(transactionAmount);

  const updatePaymentInfo = (
    e: any
    // date?: Date | null
  ) => {
    switch (e.target.name) {
      case "ParticipantType":
        /* console.log("transactionAmount:", tempTransactionAmount);
        if (e.target.value !== "Attendee" && transactionAmount !== 0) {
          setTempTransactionAmount(transactionAmount);
          setTransactionAmount(0);
          console.log("tempTransactionAmount2:", tempTransactionAmount);
        } else if (e.target.value === "Attendee") {
          console.log("tempTransactionAmount1:", tempTransactionAmount);
          setTransactionAmount(tempTransactionAmount);
        } */
        dispatch(
          storeUpdateGuestOrderItem({
            key: "ParticipantType",
            value: e.target.value,
          })
        );
        break;
      
      case "TransactionType":
        dispatch(
          storeUpdateGuestOrder({
            key: "TransactionType",
            value: e.target.value,
          })
        );
        break;

      case "CouponAmount":
        dispatch(
          storeUpdateGuestOrder({
            key: "CouponAmount",
            value: e.target.value,
          })
        );
        break;

      case "CheckNumber":
        dispatch(
          storeUpdateGuestOrder({
            key: "CheckNumber",
            value: e.target.value,
          })
        );
        break;

      case "AmountPaid":
        dispatch(
          storeUpdateGuestOrder({
            key: "AmountPaid",
            value: e.target.value,
          })
        );
        break;

      case "LateFee":
        dispatch(
          storeUpdateGuestOrder({
            key: "LateFee",
            value: e.target.value,
          })
        );
        break;

      case "AuthCode":
        dispatch(
          storeUpdateGuestOrder({
            key: "AuthCode",
            value: e.target.value,
          })
        );
        break;

      case "PIcomments":
        dispatch(
          storeUpdateGuestOrder({
            key: "Comments",
            value: e.target.value,
          })
        );
        break;

      case "NoInvoiceFlag":
        dispatch(
          storeUpdateGuestOrder({
            key: "NoInvoice",
            value: e.target.checked,
          })
        );
        break;
      default:
        console.log("default");
        break;
    }
  };

  const handleLocationChange = (event: any) => {
    console.log("handleLocationChange", JSON.parse(event.target.value));

    const selectedLocation: ILocation = eventInfo.Locations.find((location) => {
      return location.Id === parseInt(event.target.value);
    })!;

    console.log("selectedLocation", selectedLocation);
    dispatch(
      // storeUpdateOrderItem({ key: "Location", value: selectedLocation })
      storeUpdateGuestOrderItem({
        key: "Location",
        value: { ...selectedLocation, LocationId: event.target.value },
      })
    );

    // console.log("location change event:", event);
    // setAddItemButtonDisabled(false);
    // setEventLocation(JSON.parse(event.target.value));
  };

  const deleteOrder = async () => {
    console.log("DELETED");
    if (guestOrderInfo && guestOrderInfo.OrderId !== null) {
      const response = await OrderServices.cancelOrder(guestOrderInfo.OrderId);
      console.log("OrderServices.updateOrder-response", response);
      if (response.data.result != null) {
        alert("Order Deleted successfully");
        handleCancel();
        if (props.closeModal) {
          props.closeModal();
        }
      } else {
        alert(response.data.errors);
        console.log("error");
      }
    }
  };

  const handleCostChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    costparam: Cost
  ) => {
    let cost1: ICost = {
      CostId: costparam.Id as number,
      CostName: costparam.CostName,
      Cost: costparam.Cost,
      Id: null,
      // HEAD (commenting the conflict: delete later
      //      EventCostVarId: null,
      //=======
      EventCostVarId: costparam.Id as number,
      //END c7e720aa7a6fd4100e1744ce9864fc1e1c88daea
      OrderId: null,
      SeminarOrderItemId: null,
      EventId: null,
    };

    console.log("EventCostList1:", eventCostList);
    console.log("clicked cost:", cost1);

    if (event.target.checked) {
      setEventCostList((eventCost) => [...eventCost!, cost1]);
      setEventCostIdList((eventCostId) => [...eventCostId!, cost1.CostId!]);
      if (
        guestOrderInfo &&
        guestOrderInfo.Orders &&
        guestOrderInfo.Orders.length > 0 &&
        guestOrderInfo.Orders[0].ParticipantType === "Attendee"
      ) {
        dispatch(
          storeUpdateGuestOrder({
            key: "TotalAmount",
            value: (guestOrderInfo.TotalAmount ?? 0) + (costparam.Cost ?? 0),
          })
        );
        //setTransactionAmount(transactionAmount + (costparam.Cost ?? 0));
      } else {
        dispatch(
          storeUpdateGuestOrder({
            key: "TotalAmount",
            value: 0,
          })
        );
      }

      console.log("Before cost update:", guestOrderInfo);
      dispatch(storeAddGuestOrderItemCosts({ key: "Costs", value: cost1 }));

      console.log("after cost update:", guestOrderInfo);
    } else {
      setEventCostList((eventCostList) =>
        eventCostList!.filter((item) => {
          return item.CostId !== Number(event.target.id);
        })
      );
      setEventCostIdList((eventCostId) =>
        eventCostIdList!.filter((item) => {
          return item !== Number(event.target.id);
        })
      );
      dispatch(storeRemoveGuestOrderItemCosts({ key: "Costs", value: cost1 }));
      if (
        guestOrderInfo &&
        guestOrderInfo.Orders &&
        guestOrderInfo.Orders.length > 0 &&
        guestOrderInfo.Orders[0].ParticipantType === "Attendee" &&
        guestOrderInfo.TotalAmount != undefined
      ) {
        const costTotal = guestOrderInfo.TotalAmount - (costparam.Cost ?? 0);
        dispatch(
          storeUpdateGuestOrder({
            key: "TotalAmount",
            value: costTotal < 0 ? 0 : costTotal,
          })
        );
      } else {
        dispatch(
          storeUpdateGuestOrder({
            key: "TotalAmount",
            value: 0,
          })
        );
      }
    }
    console.log("EventCostList2:", eventCostList);
  };

  // const callCreateOrderAPI = async () => {
  //   // alert("callCreateOrderAPI");
  //   console.log("onSUBMIT:", guestOrderInfo);
  //   setModalOpen(false);
  //   const apiBody: any = guestOrderInfo;
  //   const response = await OrderServices.createGuestOrder(apiBody);
  //   dispatch(resetOrderParameters());
  //   setOrderEventDetailModalOpen(false);
  //   console.log("response", response);
  //   // alert("response received");
  //   if (response.data.data != null) {
  //     alert("Order Created successfully");
  //     // dispatch(resetOrderParameters());  I am doing this in useEffect
  //     // navigate("/order", { replace: true });
  //     // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
  //     // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));

  //     dispatch(
  //       storeUpdateOrder({
  //         key: "TransactionAmount",
  //         value: 0,
  //       })
  //     );

  //     // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
  //     // navigate("/member", { replace: false });
  //     // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
  //     //  dispatch(screenChange("Events"));
  //   } else {
  //     alert(response.data.errors);
  //     console.log("error");
  //   }
  // };

  const handleVideoCostChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    videoCostParam: IVideoCost
  ) => {
    let cost1: IVideoCost = {
      Id: videoCostParam.Id,
      CostName: videoCostParam.CostName,
      Cost: videoCostParam.Cost,
    };

    // console.log("EventCostList1:", eventCostList);
    // console.log("clicked cost:", cost1);

    if (event.target.checked) {
      /* if (
        guestOrderInfo &&
        guestOrderInfo.Orders &&
        guestOrderInfo.Orders.length > 0 &&
        // guestOrderInfo.Orders[0].ParticipantType === "Attendee" &&
        videoCostParam.Cost
      ) {
        setTransactionAmount(videoCostParam.Cost);
      } else {
        setTransactionAmount(0);
      } */

      // console.log("Before cost update:", orderInfo);
      dispatch(
        storeAddGuestOrderItemVideoCost({ key: "VideoCost", value: cost1 })
      );
      dispatch(
        storeUpdateOrder({
          key: "TransactionAmount",
          value: videoCostParam.Cost as number,
        })
      );
      // console.log("after cost update:", orderInfo);
    } else {
      dispatch(
        storeRemoveGuestOrderItemVideoCost({ key: "VideoCost", value: cost1 })
      );
      // There will be only one entry in this array at any time. so while removing it, I am making
      // everything null
      /* setTransactionAmount(0);

      dispatch(
        storeUpdateOrder({
          key: "TransactionAmount",
          value: 0,
        })
      ); */
    }
    // console.log("EventCostList2:", eventCostList);
  };

  const handleCancel = () => {
    // setOrderEventDetailModalOpen(false);
    setEventCostList([]);
    setEventCostIdList([]);
    //setTransactionAmount(0);
    // dispatch(resetOrderParameters());
  };

  const checkRequiredFields = () => {
    let missingFields: string = "Required Fields Missing: ";
    if (
      guestOrderInfo.Orders[0].ParticipantType == undefined ||
      guestOrderInfo.Orders[0].ParticipantType == ""
    ) {
      missingFields = missingFields + " ParticipantType, ";
    }
    /* if (
      guestOrderInfo.TransactionType == undefined ||
      guestOrderInfo.TransactionType == ""
    ) {
      missingFields = missingFields + "Payment Type, ";
    } */

    if (missingFields !== "Required Fields Missing: ") {
      console.log("missingFields1:", missingFields);
      alert(missingFields);
      return true;
    } else {
      console.log("No missing field");
      return false;
    }
  };

  const checkIsLocationSelected = () => {
    //console.log(eventLocation);
    if (guestOrderInfo.Orders[0].Location == undefined) {
      alert("Please select Event Location");
      return true;
    } else {
      return false;
    }
  };

  const checkIsCostSelected = () => {
    if (
      guestOrderInfo.Orders[0].Costs == undefined ||
      guestOrderInfo.Orders[0].Costs.length == 0
    ) {
      alert("Please select Event Cost");
      return true;
    } else {
      return false;
    }
  };

  const checkIsAmountPaidEntered = () => {
    if (
      guestOrderInfo.AmountPaid == undefined ||
      guestOrderInfo.AmountPaid > 0
    ) {
      return false;
    } else {
      alert("Please enter Amount");
      return true;
    }
  };

  const checkIsAmountPaid = () => {
    if (
      guestOrderInfo.TotalAmount == undefined ||
      guestOrderInfo.AmountPaid == undefined ||
      (guestOrderInfo.AmountPaid + guestOrderInfo.CouponAmount) > guestOrderInfo.TotalAmount
    ) {
      const userResponse = window.confirm(
        "Amount Paid is more than Total Amount. Do you want to Continue"
      );
      if (userResponse) {
        return false;
      } else {
        return true;
      }
    } else if (
      guestOrderInfo.TotalAmount == undefined ||
      (guestOrderInfo.AmountPaid + guestOrderInfo.CouponAmount) < guestOrderInfo.TotalAmount
    ) {
      const userResponse = window.confirm(
        "Amount Paid is less than Total Amount. Do you want to Continue"
      );
      if (userResponse) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  };

  const addOrderItem = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (
      guestOrderInfo.FirstName === undefined ||
      guestOrderInfo.FirstName === null
    ) {
      alert("First Name is required field");
      return;
    }

    if (
      guestOrderInfo.LastName === undefined ||
      guestOrderInfo.LastName === null
    ) {
      alert("Last Name is required field");
      return;
    }

    //  HEAD
    // =======
    /* if (
      guestOrderInfo.PhoneNumber == null ||
      guestOrderInfo.PhoneNumber == ""
    ) {
      alert("Phone Number is Invalid");
      return;
    } */

    // END c7e720aa7a6fd4100e1744ce9864fc1e1c88daea
    if (checkRequiredFields()) {
      return;
    }
    if (checkIsLocationSelected()) {
      return;
    }
    /* if (checkIsCostSelected()) {
      return;
    } */
    /* if (checkIsAmountPaidEntered()) {
      return;
    } */
    if (checkIsAmountPaid()) {
      return;
    }

    const dueAmount =
      guestOrderInfo.TotalAmount - ((guestOrderInfo.AmountPaid ?? 0) + (guestOrderInfo.CouponAmount ?? 0));
    dispatch(
      storeUpdateGuestOrderItem({
        key: "DueAmount",
        value: dueAmount < 0 ? 0 : dueAmount,
      })
    );

    dispatch(
      storeUpdateGuestOrderItem({
        key: "EventId",
        value: eventInfo.Id,
      })
    );
    dispatch(
      storeUpdateGuestOrderItem({
        key: "OrderType",
        value: eventInfo.EventType!,
      })
    );

    setCallAPIflag(true);
    // props.callOrderAPI();
    handleCancel();
  };

  return (
    <>
      <form
        className="form-wrapper"
        onSubmit={(e) => addOrderItem(e)}
        noValidate
      >
        <div className="section-box">
          <h3 className="section-heading">Personal Information</h3>
          {/* <div
            className="dashboard-content-wrapper dashboard-wrapper-sticky-submit-button"
            style={{ paddingBottom: "5px" }}
          > */}
          <div className="form-wrapper">
            <div className="input-field-div-wrapper">
              <input
                className="input-field-div-small w-100"
                id="FirstName"
                {...register("FirstName" as "FirstName", {
                  required: "FirstName is a required field",
                })}
                placeholder=""
                name="FirstName"
                onChange={(e) => {
                  updatePersonalInfo(e);
                }}
                value={guestOrderInfo.FirstName ?? ""}
              />
              <label className="form-label" htmlFor="FirstName">
                * First Name
              </label>
              <p className="form-error form-error-position">
                {errors.FirstName?.message}
              </p>
            </div>

            <div className="input-field-div-wrapper">
              <input
                className="input-field-div-small w-100"
                id="LastName"
                {...register("LastName" as "LastName", {
                  required: "LastName is a required field",
                })}
                placeholder=""
                onChange={(e) => {
                  updatePersonalInfo(e);
                }}
                value={guestOrderInfo.LastName ?? ""}
              />
              <label className="form-label" htmlFor="LastName">
                * Last Name
              </label>
              <p className="form-error form-error-position">
                {errors.LastName?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper">
              <select
                className="dropdown-control-large-insidetextfield"
                name="Gender"
                onChange={(e) => {
                  updatePersonalInfo(e);
                }}
                value={guestOrderInfo.Gender ?? ""}
              >
                <option value={""}> Select Gender </option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Unspecified">Unspecified</option>
              </select>
            </div>
            <div
              className="input-addressfield-div mt-2"
              style={{ width: "49%" }}
            >
              <input
                className="input-field-div-small w-100"
                placeholder=""
                id="Address1"
                name="Address1"
                onChange={(e) => {
                  updatePersonalInfo(e);
                }}
                value={guestOrderInfo.Address1 ?? ""}
              />
              <label className="form-label" htmlFor="Address1">
                Address 1
              </label>
            </div>
            <div
              className="input-addressfield-div mt-2"
              style={{ width: "49%" }}
            >
              <input
                className="input-field-div-small w-100"
                placeholder=""
                id="Address2"
                name="Address2"
                onChange={(e) => {
                  updatePersonalInfo(e);
                }}
                value={guestOrderInfo.Address2 ?? ""}
              />
              <label className="form-label" htmlFor="Address2">
                Address 2
              </label>
            </div>
            <div className="input-field-div-wrapper">
              <input
                className="input-field-div-small w-100"
                id="City"
                name="City"
                placeholder=""
                onChange={(e) => {
                  updatePersonalInfo(e);
                }}
                value={guestOrderInfo.City ?? ""}
              />
              <label className="form-label" htmlFor="City">
                City
              </label>
            </div>
            <div className="input-field-div-wrapper">
              <select
                className="dropdown-control-large-insidetextfield"
                name="State"
                onChange={(e) => {
                  updatePersonalInfo(e);
                }}
                value={guestOrderInfo.State ?? ""}
              >
                <option value={""}> Select State </option>
                {configurationList.StateList?.map((State: any) => (
                  <option key={State.Id} value={State.StateName}>
                    {State.StateName}
                  </option>
                ))}
                ;
              </select>
            </div>

            <div className="input-field-div-wrapper">
              {/* <Label>Zip Code</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="Zipcode"
                name="Zipcode"
                autoComplete="off"
                type="number"
                pattern="[0-9]*"
                value={guestOrderInfo.Zipcode ?? ""}
                onChange={(e) => {
                  updatePersonalInfo(e);
                }}
              />
              <label className="form-label" htmlFor="Zipcode">
                Zipcode
              </label>
            </div>

            <div className="input-field-div-wrapper">
              <input
                className="input-field-div-small w-100"
                placeholder=""
                id="PhoneNumber"
                type="text"
                pattern="[0-9]*"
                onChange={(e) => {
                  updatePersonalInfo(e);
                }}
                value={formatPhoneNumber(guestOrderInfo.PhoneNumber) ?? ""}
              />
              <label className="form-label" htmlFor="PhoneNumber">
                Phone Number
              </label>
            </div>
            <div className="input-field-div-wrapper">
              <input
                className="input-field-div-small w-100"
                placeholder=""
                id="Email"
                name="Email"
                onChange={(e) => {
                  updatePersonalInfo(e);
                }}
                value={guestOrderInfo.Email ?? ""}
              />
              <label className="form-label" htmlFor="Email">
                Email ID
              </label>
            </div>

            {/* <div className="horizontal-wrapper-centeralign">
                <Button
                  className="submit-button-div"
                  type="button"
                  onClick={(e) => openOrderEventDetail(e)}
                >
                  Next
                </Button>
              </div> */}
          </div>
          {/* </div> */}
        </div>
        <div className="section-box">
          <h3 className="section-heading">Cost and Payment Information</h3>
          <div className="horizontal-wrapper-spacebetween">
            {eventInfo.EventType !== "Video" ? (
              <div className="input-field-div-wrapper">
                <select
                  className="dropdown-control-large-insidetextfield"
                  name="ParticipantType"
                  onChange={(e) => {
                    updatePaymentInfo(e);
                  }}
                  value={
                    guestOrderInfo &&
                    guestOrderInfo.Orders &&
                    guestOrderInfo.Orders.length > 0 &&
                    guestOrderInfo.Orders[0] !== null
                      ? guestOrderInfo.Orders[0].ParticipantType!
                      : ""
                  }
                >
                  <option value={""}> Select Participant Type </option>
                  <option value="Attendee">Attendee</option>
                  <option value="Moderator">Moderator</option>
                  <option value="Speaker">Speaker</option>
                </select>
              </div>
            ) : (
              <></>
            )}
            <div className="input-field-div-wrapper">
              <select
                className="dropdown-control-large-insidetextfield"
                name="TransactionType"
                onChange={(e) => {
                  updatePaymentInfo(e);
                }}
                value={guestOrderInfo.TransactionType ?? ""}
              >
                <option value={""}> Select Payment Type </option>
                <option value="Online">American Express</option>
                <option value="Offline">Authorize.net</option>
                <option value="Check">Check</option>
                <option value="Discover">Discover</option>
                <option value="MasterCard">MasterCard</option>
                <option value="Visa">Visa</option>
                <option value="Offline">Website</option>
              </select>
            </div>

            <div style={{ width: "28%", marginBottom: "1.8rem" }}>
              <Controller
                control={control}
                name="DatePaid"
                // rules={{ required: "* required field" }}
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <ThemeProvider theme={muiDatePickerColorTheme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="datepicker-local"
                        label="Date Paid"
                        value={dayjs(datePaid)}
                        onChange={(date: any) => {
                          setDatePaid(dayjs(date));
                        }}

                        // onChange={(date: any) => {
                        //   date && setStartDateTime(date);
                        //   updateDateField(date, "StartDateTime");
                        // }}
                      />
                    </LocalizationProvider>
                  </ThemeProvider>
                )}
              />
            </div>

            <div className="input-field-div-wrapper">
              <input
                className="input-field-div-small"
                id="CheckNumber"
                name="CheckNumber"
                placeholder=""
                onChange={(e) => {
                  updatePaymentInfo(e);
                }}
                value={guestOrderInfo.CheckNumber ?? ""}
                disabled={false}
                autoComplete="off"
              />
              <label className="form-label" htmlFor="CheckNumber">
                Check Number
              </label>
            </div>

            <div className="input-field-div-wrapper">
              <input
                className="input-field-div-small"
                id="LateFee"
                name="LateFee"
                placeholder=""
                pattern="[0-9]*"
                onChange={(e) => {
                  updatePaymentInfo(e);
                }}
                value={guestOrderInfo.LateFee ?? 0}
                disabled={false}
                autoComplete="off"
              />
              <label className="form-label" htmlFor="LateFee">
                Late Fee
              </label>
            </div>

            <div className="input-field-div-wrapper">
              <input
                className="input-field-div-small"
                id="AuthCode"
                name="AuthCode"
                placeholder=""
                onChange={(e) => {
                  updatePaymentInfo(e);
                }}
                value={guestOrderInfo.AuthCode ?? ""}
                disabled={false}
                autoComplete="off"
              />
              <label className="form-label" htmlFor="AuthCode">
                Auth Code
              </label>
            </div>

            {/* <div className="order"> */}
            <div
              className="horizontal-wrapper-spacebetween-center"
              style={{ width: "48%" }}
            >
              {/* <div className="input-field-div-wrapper" style={{ width: "100%" }}> */}
              {eventInfo.EventType !== "Video" ? (
                <div
                  className="input-field-div-wrapper-large-nominwidth-nomargin wrapper-minwidth-180px"
                  style={{ width: "100%", height: "auto" }}
                >
                  <h5 className="section-heading-small">Select Location</h5>
                  <select
                    className="dropdown-control-large-insidetextfield"
                    id="Location"
                    // placeholder=""
                    style={{ color: "#25284e" }}
                    onChange={(e) => {
                      handleLocationChange(e);
                    }}
                    value={
                      guestOrderInfo &&
                      guestOrderInfo.Orders &&
                      guestOrderInfo.Orders.length > 0 &&
                      guestOrderInfo.Orders[0] !== null &&
                      guestOrderInfo.Orders[0].Location &&
                      guestOrderInfo.Orders[0].Location.LocationId
                        ? guestOrderInfo.Orders[0].Location.LocationId!
                        : ""
                    }
                  >
                    <option value={""}> Select Location </option>
                    {eventInfo.Locations?.map((location) => (
                      <option key={location.Id} value={location.Id!}>
                        {/* {Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(location.Cost as number)}- */}
                        {location.Location}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                <></>
              )}
              {/* </div> */}
              {/* </div> */}
              {/* start of cost change */}
              {/* <div className="input-field-div-wrapper"> */}
              <div
                className="costlist"
                style={{ width: "100%", height: "auto", marginTop: "1rem" }}
              >
                {typeof eventInfo.Costs != "undefined" &&
                eventInfo.EventType !== "Video" ? (
                  <>
                    {/* <div id="CostList"> */}
                    <h5 className="section-heading-small">Select Cost</h5>
                    {eventInfo.Costs.map((cost) => {
                      return (
                        <div key={cost.Id} className="checkboxgroup">
                          <input
                            id={String(cost.Id)}
                            className="checkbox"
                            type="checkbox"
                            defaultChecked={
                              guestOrderInfo &&
                              guestOrderInfo.Orders &&
                              guestOrderInfo.Orders.length > 0 &&
                              guestOrderInfo.Orders[0] &&
                              guestOrderInfo.Orders[0].Costs &&
                              guestOrderInfo.Orders[0].Costs.length > 0
                                ? guestOrderInfo.Orders[0].Costs.some(
                                    (eventCostList) =>
                                      eventCostList.EventCostVarId === cost.Id
                                  )
                                : false
                            }
                            onChange={(event) => handleCostChange(event, cost)}
                          />
                          <div className="costname-item">
                            {Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(cost.Cost as number)}
                            -{cost.CostName}
                          </div>
                          {/* <span style={{ marginLeft: "5px", color: "#03c04A" }}>
                          {isActive ? "(Purchased)" : <></>}
                        </span> */}
                        </div>
                      );
                    })}
                    {/* </div> */}
                  </>
                ) : eventInfo.EventType === "Video" ? (
                  <>
                    <h5 className="section-heading-small">Select Cost</h5>
                    {videoCostList.map((cost) => {
                      return (
                        <div key="1" className="checkboxgroup">
                          <input
                            id={String(cost.Id)}
                            className="checkbox"
                            type="checkbox"
                            defaultChecked={
                              guestOrderInfo &&
                              guestOrderInfo.Orders &&
                              guestOrderInfo.Orders.length > 0 &&
                              guestOrderInfo.Orders[0] &&
                              guestOrderInfo.Orders[0].VideoCost &&
                              guestOrderInfo.Orders[0].VideoCost.length > 0
                                ? guestOrderInfo.Orders[0].VideoCost.some(
                                    (eventCostList) =>
                                      eventCostList.CostName === cost.CostName
                                  )
                                : false
                            }
                            onChange={(event) =>
                              handleVideoCostChange(event, cost)
                            }
                          />
                          <div className="costname-item">
                            {Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(cost.Cost as number)}
                            -{cost.CostName}
                          </div>

                          {/* <span style={{ marginLeft: "5px", color: "#03c04A" }}>
                            {isActive ? "(Purchased)" : <></>}
                          </span> */}
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
            {/* end of cost change */}
            {/* </div> */}

            <div
              // className="textarea-wrapper"
              style={{ width: "48%" }}
            >
              <TextField
                className="textarea"
                id="PIcomments"
                name="PIcomments"
                placeholder="Notes"
                multiline
                rows={4}
                onChange={(e) => {
                  updatePaymentInfo(e);
                }}
                value={guestOrderInfo.Comments}
              />
              {/* <label className="form-label" htmlFor="PIcomments">
              Comments
            </label> */}
            </div>
            <div className="horizontal-wrapper-spacebetween-center">
              <div
                className="order-checkboxgroup"
                style={{ marginTop: "1rem", width: "28%" }}
              >
                <input
                  id="NoInvoiceFlag"
                  name="NoInvoiceFlag"
                  className="checkbox"
                  type="checkbox"
                  onChange={(e) => updatePaymentInfo(e)}
                />
                <div>
                  <span> No Invoice</span>
                </div>
              </div>
              <div
                className="input-field-div-wrapper w-18"
                style={{ marginTop: "2rem" }}
              >
                <input
                  className="input-field-div-small"
                  id="TotalAmount"
                  name="TotalAmount"
                  pattern="[0-9]*"
                  placeholder=""
                  onChange={(e) => {
                    updatePaymentInfo(e);
                  }}
                  value={guestOrderInfo.TotalAmount ?? 0}
                  disabled={true}
                  autoComplete="off"
                />
                <label className="form-label" htmlFor="TotalAmount">
                  Total Amount
                </label>
              </div>
              <div className="input-field-div-wrapper w-18" style={{ marginTop: "2rem"}}>
                <input
                  className="input-field-div-small"
                  id="CouponAmount"
                  name="CouponAmount"
                  pattern="[0-9]*"
                  placeholder=""
                  onChange={(e) => {
                    updatePaymentInfo(e);
                  }}
                  value={guestOrderInfo.CouponAmount ?? 0}
                  autoComplete="off"
                />
                <label className="form-label" htmlFor="CouponAmount">
                  Discount Amount
                </label>
              </div>
              <div
                className="input-field-div-wrapper w-18"
                style={{ marginTop: "2rem" }}
              >
                <input
                  className="input-field-div-small"
                  id="AmountPaid"
                  name="AmountPaid"
                  pattern="[0-9]*"
                  placeholder=""
                  onChange={(e) => {
                    updatePaymentInfo(e);
                  }}
                  value={guestOrderInfo.AmountPaid ?? 0} 
                  autoComplete="off"
                />
                <label className="form-label" htmlFor="AmountPaid">
                  Amount Paid
                </label>
              </div>
            </div>
            <div className="horizontal-wrapper-centeralign">
              <div className="submit-button-div ">
                <Button type="submit">Submit</Button>
              </div>
              {props.operationType === "EDIT" ? (
                        <div className="submit-button-div-small-delete ">
                          <DeleteButton type="button" onClick={deleteOrder}>
                            Delete
                          </DeleteButton>
                        </div>
                      ) : (
                        <></>
                      )}
            </div>
          </div>
          {/* <EventMemberPaymentInfo callOrderAPI={callCreateOrderAPI} /> */}
        </div>
      </form>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default EventAddGuest;
